import { useSiteDashboard } from '@/hooks/useSiteDashboard';
import { DollarSign } from 'lucide-react';
import type { OperatorDashboardData, OperatorDashboardPeriod } from '@evi/shared';
import { RevenueChart } from '@evi/ui';
import ChartPlaceholder from './ChartPlaceholder';

export default function ChartRevenue({
  summary,
  period,
  onPeriodChange,
}: {
  summary: OperatorDashboardData | undefined;
  period: OperatorDashboardPeriod;
  onPeriodChange: (next: OperatorDashboardPeriod) => void;
}) {
  const isSite = useSiteDashboard();
  // Site roles read "charging sales", never "revenue", and get no RATE:
  // CURRENT footer. Every Site-only prop is undefined for the operator, so
  // the chart's defaults render the operator's output unchanged.
  return summary ? (
    <RevenueChart
      titleLabel={isSite ? 'CHARGING SALES: USD' : undefined}
      periodAriaLabel={isSite ? 'Charging sales period' : undefined}
      emptyNoun={isSite ? 'charging sales' : undefined}
      showRate={isSite ? false : undefined}
      data={summary.revenueLast24h}
      currentRate={summary.currentRateUsdHr}
      period={period}
      onPeriodChange={onPeriodChange}
    />
  ) : (
    <ChartPlaceholder title={isSite ? 'Charging sales last 24h' : 'Revenue last 24h'} icon={DollarSign} desc="Loading…" />
  );
}
